import React, { useEffect } from 'react'
import ReportingAdapter from './reporting-adapter'
import { useFlags } from 'gatsby-plugin-launchdarkly'
import { EventPrefix, Trigger } from '@pathccm/common-analytics/events'

const PageRouter: React.FC<{ children: React.ReactNode | null }> = ({ children }) => {
  const { marketingSiteSegmentTransition } = useFlags()

  useEffect(() => {
    if (marketingSiteSegmentTransition === undefined) return

    const reportingAdapter = new ReportingAdapter(marketingSiteSegmentTransition)
    reportingAdapter.page({ prefix: EventPrefix.MARKETING_SITE })
  }, [marketingSiteSegmentTransition])

  return <>{children}</>
}

export default PageRouter
